import { message, Modal } from "antd";
import React from "react";
import {
    convertQuestion,
    QuestionListItem,
    QuestionType,
    removeQuestion,
    saveQuestion
} from "service/exercise";
import { errorMessage } from "service/service";
import usePromiseCallback from "utils/usePromiseCallback";
import TopicDetail from "../TopicDetail";
import style from "./index.module.scss";
import AddTopicModal from "../AddTopicModal";
import useModalHandler from "utils/useModalHandler";

interface TopicContentProps {
    currentData: QuestionListItem;
    exerciseId: string;
    refreshData: () => void;
}

export default function TopicContent({
    currentData,
    exerciseId,
    refreshData
}: TopicContentProps) {
    const topicModal = useModalHandler();
    const question = convertQuestion(currentData);

    //删除题目
    const onDelete = usePromiseCallback(async function () {
        Modal.confirm({
            title: `确认删除题目吗？`,
            onOk: async () => {
                try {
                    await removeQuestion(exerciseId, String(currentData.id));
                    message.success("删除成功!");
                    refreshData();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    });

    async function onQuestionChange(question: QuestionType) {
        await saveQuestion({
            ...question,
            paperId: String(currentData.paperId),
            id: String(currentData.id)
        });
        message.success("保存成功!");
        refreshData();
    }

    return (
        <div className={style.root}>
            <div className={style.tools}>
                <button
                    className={style.edit}
                    title="修改"
                    onClick={topicModal.open}
                />
                <button
                    className={style.delete}
                    title="删除"
                    onClick={onDelete}
                />
            </div>

            {/* 单题干 */}
            {currentData.queTypeId < 6 && <TopicDetail data={currentData} />}

            {/* 多题干 */}
            {currentData.queTypeId > 5 && (
                <div>
                    <div className={style.info}>
                        <em>{currentData.index}.</em>（{currentData.queTypeName}
                        ，{currentData.score || 0}分）
                    </div>
                    <div className={style.trunk}>
                        <div
                            className={style.title}
                            dangerouslySetInnerHTML={{
                                __html: currentData?.contentText
                            }}
                        />
                    </div>

                    {currentData.questionModelList.map(
                        (item: any, index: number) => (
                            <div className={style.item} key={item.id}>
                                <TopicDetail data={item} index={index + 1} />
                            </div>
                        )
                    )}
                </div>
            )}

            {topicModal.render(
                <AddTopicModal
                    key={question.id}
                    title="编辑题目"
                    initialValue={question}
                    onOk={onQuestionChange}
                />
            )}
        </div>
    );
}
